import { ErrorIcon } from '@library/components/ErrorIcon';
import { Message } from '@library/components/messages/Message';

export interface ErrorMessageProps {
  failureMessages: Array<string>;
  failedValidation: boolean;
  testId?: string;
}

export function ErrorMessage({
  failureMessages,
  failedValidation,
  testId = undefined
}: ErrorMessageProps) {
  return (
    failedValidation && (
      <div
        className="text-roses flex items-start pt-1 text-xs leading-3"
        data-testid={testId}
      >
        <div className="pt-1">
          <ErrorIcon />
        </div>

        <div className="flex flex-col">
          {failureMessages?.map((message) => (
            <Message
              className="text-sm"
              code="ERROR"
              key={message}
              message={message}
            />
          ))}
        </div>
      </div>
    )
  );
}
